import React from 'react';
import { Award, Shield, CheckCircle2, Leaf } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardContent } from '../components/ui/card';

const Certificates = () => {
  const { t, language } = useLanguage();

  const certificates = [
    {
      title: 'ISO 9001:2015',
      category: language === 'en' ? 'Quality Management' : 'إدارة الجودة',
      description: language === 'en' ? 'International standard for quality management systems.' : 'المعيار الدولي لأنظمة إدارة الجودة.',
      icon: Award
    },
    {
      title: 'ISO 14001:2015',
      category: language === 'en' ? 'Environmental Management' : 'الإدارة البيئية',
      description: language === 'en' ? 'Environmental management system certification.' : 'شهادة نظام الإدارة البيئية.',
      icon: Leaf
    },
    {
      title: 'ISO 45001:2018',
      category: language === 'en' ? 'Occupational Health & Safety' : 'الصحة والسلامة المهنية',
      description: language === 'en' ? 'Occupational health and safety management certification.' : 'شهادة إدارة الصحة والسلامة المهنية.',
      icon: Shield
    },
    {
      title: language === 'en' ? 'Saudi Contractors Authority' : 'هيئة المقاولين السعودية',
      category: language === 'en' ? 'KSA Registration' : 'التسجيل في المملكة',
      description: language === 'en' ? 'Registered contractor with Saudi Authority.' : 'مقاول مسجل لدى الهيئة السعودية.',
      icon: CheckCircle2
    },
    {
      title: language === 'en' ? 'Local Content Certified' : 'معتمد من المحتوى المحلي',
      category: language === 'en' ? 'Saudi Local Content Authority' : 'هيئة المحتوى المحلي والمشتريات الحكومية',
      description: language === 'en' ? 'Certified by Saudi Local Content and Government Procurement Authority.' : 'معتمد من هيئة المحتوى المحلي والمشتريات الحكومية السعودية.',
      icon: Award
    },
    {
      title: language === 'en' ? 'Ministry of Municipalities & Housing Approved Contractor' : 'مقاول معتمد من وزارة الشؤون البلدية والإسكان',
      category: language === 'en' ? 'Government Accreditation' : 'الاعتماد الحكومي',
      description: language === 'en' ? 'Approved contractor by the Ministry of Municipalities and Housing.' : 'مقاول معتمد من وزارة الشؤون البلدية والإسكان.',
      icon: Award
    },
  ];

  return (
    <div className="min-h-screen pt-24 pb-20">
      {/* Hero */}
      <section className="bg-[#141F48] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{t('certificatesTitle')}</h1>
          <p className="text-xl text-[#D3BC8D] font-medium">{t('certificatesSubtitle')}</p>
        </div>
      </section>

      {/* Certificates Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {certificates.map((cert, index) => {
              const Icon = cert.icon;
              return (
                <Card key={index} className="border-2 border-[#D3BC8D] hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                  <CardContent className="p-8">
                    <div className="w-16 h-16 bg-[#141F48] rounded-full flex items-center justify-center mx-auto mb-4">
                      <Icon className="w-8 h-8 text-[#D3BC8D]" />
                    </div>
                    <h3 className="text-xl font-bold text-[#141F48] text-center mb-2">{cert.title}</h3>
                    <p className="text-[#D3BC8D] text-center font-medium mb-3">{cert.category}</p>
                    <p className="text-gray-600 text-center leading-relaxed">{cert.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Commitment Statement */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-[#141F48] mb-6">
            {language === 'en' ? 'Our Commitment' : 'التزامنا'}
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            {language === 'en'
              ? 'ALMAD Contracting maintains the highest standards of quality, safety, and environmental responsibility. Our certifications demonstrate our commitment to excellence and continuous improvement in all aspects of our operations.'
              : 'تحافظ شركة المعد للمقاولات على أعلى معايير الجودة والسلامة والمسؤولية البيئية. تُظهر شهاداتنا التزامنا بالتميز والتحسين المستمر في جميع جوانب عملياتنا.'}
          </p>
        </div>
      </section>
    </div>
  );
};

export default Certificates;